import { render, staticRenderFns } from "./Davis.vue?vue&type=template&id=07ca7952"
import script from "./Davis.vue?vue&type=script&lang=js"
export * from "./Davis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports